"use strict";
/**
 * @file Created on Fri Aug 24 2018
 * @author VBr
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var ValidationLevel_1 = require("../ValidationLevel");

var ValidationResult_1 = require("../ValidationResult");

var Validator_1 = require("../Validator");
/**
 * Validator that checkes number's in range
 */


var NumberInRangeValidator =
/*#__PURE__*/
function (_Validator_1$Validato) {
  _inherits(NumberInRangeValidator, _Validator_1$Validato);

  function NumberInRangeValidator(min, max) {
    var _this;

    _classCallCheck(this, NumberInRangeValidator);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(NumberInRangeValidator).call(this, ValidationLevel_1.ValidationLevel.Fast));
    _this.min = min;
    _this.max = max;
    return _this;
  }

  _createClass(NumberInRangeValidator, [{
    key: "doValidate",
    value: function doValidate(value) {
      if (this.min !== null && value < this.min) {
        if (this.min === 0) {
          return new ValidationResult_1.ValidationError('value__must_be_positive_number', this.min);
        }

        return new ValidationResult_1.ValidationError(NumberInRangeValidator.UNDER_MIN_VALUE_ERROR, this.min.toString());
      }

      if (this.max !== null && value > this.max) {
        return new ValidationResult_1.ValidationError(NumberInRangeValidator.OVER_MAX_VALUE_ERROR, this.max.toString());
      }

      return new ValidationResult_1.ValidationSuccess(value);
    }
  }]);

  return NumberInRangeValidator;
}(Validator_1.Validator);

exports.NumberInRangeValidator = NumberInRangeValidator;
NumberInRangeValidator.UNDER_MIN_VALUE_ERROR = 'UNDER_MIN_VALUE';
NumberInRangeValidator.OVER_MAX_VALUE_ERROR = 'OVER_MAX_VALUE';